window.addEventListener( 'load', () => {
  const productList = document.querySelectorAll('.list-view-items-instroke');

  productList.forEach( productCard => {
    const variantList = productCard.querySelectorAll('.pcp-variant-option'),
          dropdownSelector = productCard.querySelector('.miscellaneous_select'),
          comparePriceElement = productCard.querySelector('.mutable-compare-price'),
          productPriceElement = productCard.querySelector('.mutable-product-price');
 
    appendPriceDiffToDropdownOptions();
    changePriceOnVariantSelect();


    function appendPriceDiffToDropdownOptions(){
      variantList.forEach( variantOption => {
        const variantPrice = variantOption.dataset.variantPrice;
        const priceDifference = variantPrice - dropdownSelector.dataset.lowestProductPrice;

        if (priceDifference > 0) {
          variantOption.innerHTML += ` +$${priceDifference % 100 === 0 ? priceDifference / 100 : (priceDifference / 100).toFixed(2)}`;
        }
      })
    }

    function changePriceOnVariantSelect(){ 
      dropdownSelector.addEventListener( 'change', dropdownEl => {
        const selectedVariantPrice = dropdownEl.target.selectedOptions[0].dataset.variantPrice / 100,
              selectedVariantComparePrice = dropdownEl.target.selectedOptions[0].dataset.variantCompareAtPrice / 100;

        productPriceElement.innerHTML = `$${selectedVariantPrice.toFixed(2)}`;
        if (selectedVariantComparePrice > 0) {
          comparePriceElement.innerHTML = `$${selectedVariantComparePrice.toFixed(2)}`;
        }
      })
    }

  })
})
